var leftNavBrandFilter = () => {
  var originalBrandCount = $('.brand_scroll ul li:visible').length;
  $('.brandCount').text(originalBrandCount + " brands available");

    if ($('.search_by_brand_filter input').length > 0) {
        var $list = $('.search_by_brand_filter + .brand_scroll .facet li');
        $('#search-by-brand-filter-input').keyup(function () {
            var filter = $(this).val().replace(/\s/g, '');
            $list.each(function () {
                ($(this).text().replace(/\s/g, '').search(new RegExp(filter, "i")) < 0) ? $(this).fadeOut(): $(this).show();
            });
            setTimeout(function() {
              var $brandSearchCount = $('.brand_scroll ul li:visible').length;
              $('.brandCount').text($brandSearchCount + " brands available");
            }, 500);
        });
    };

    const setBrandSearchARIA = (icon, role, title) => {
        icon.attr('aria-role', role);
        icon.attr('aria-title', title);
    }

    const setBrandSearchIcon = (open, icon, role, title) => {
        let srClearBrandSearch = "<span role='button' id='srClearBrandSearch' class='sr-only' tabindex='0' onkeypress='$(\".search_by_brand_filter .search-icon\").trigger(\"click\");'>Clear</span>";
        if (open) {
            icon.addClass('open');
            if (!$('#srClearBrandSearch').length > 0) $(srClearBrandSearch).insertAfter('.search_by_brand_filter .search-icon');
        } else {
            icon.removeClass('open');
            if ($('#srClearBrandSearch').length > 0) $('#srClearBrandSearch').remove();
        }
        setBrandSearchARIA(icon, role, title);
    }

    var $brandInput = $('#search-by-brand-filter-input');

    $brandInput.keyup(function () {
        var searchIcon = $(".search_by_brand_filter .search-icon");
        ($(this).val().length > 0) ? setBrandSearchIcon(true, searchIcon, 'button', 'Clear Brand Search'): setBrandSearchIcon(false, searchIcon, '', '');
    });

    $("body").on('click', '.search_by_brand_filter .search-icon.open', function (e) {
        $brandInput.val('');
        setBrandSearchIcon(false, $(this), '', '');
        $(".search_by_brand_filter + .brand_scroll .facet li").show();
    });
};

var touch_leftNavBrandFilter = () => {
    if ($('.landing-brand-facet-wrapper').length > 0) {
        var brandWrapper, brandList;
        if ($('.mobilePage').length > 0) {
            let brandFacetWrapper_m = '.mobile-menu-categories .landing-brand-facet-wrapper';
            brandWrapper = $(brandFacetWrapper_m);
            brandList = $(`${brandFacetWrapper_m} ul.facet`);
        } else {
            brandWrapper = $('.landing-brand-facet-wrapper');
            brandList = $('.landing-brand-facet-wrapper ul.facet');
            brandWrapper.prependTo($('.facet-inner'));
        }
        $('.landing-brand-facet-title').on('click', function () {
            let active = 'brandActive';
            if (brandWrapper.hasClass(active)) {
                brandWrapper.removeClass(active);
                brandList.slideUp();
            } else {
                brandWrapper.addClass(active);
                brandList.slideDown();
            }
        });
    }
}

export {
    leftNavBrandFilter,
    touch_leftNavBrandFilter
}
